import { render } from "./AcademicCheckManagement.vue?vue&type=template&id=2a4baaac&scoped=true"
import script from "./AcademicCheckManagement.vue?vue&type=script&lang=js"
export * from "./AcademicCheckManagement.vue?vue&type=script&lang=js"

import "./AcademicCheckManagement.vue?vue&type=style&index=0&id=2a4baaac&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4baaac"]])

export default __exports__